import React from "react";
import { Link } from "react-router-dom";
import StaffManagementConst from "../staff-management-const";


const StaffManagementEventLinkField = ({ id, title }) => (
    <Link
        className="staff-management-list__event-title"
        to={ {
            pathname: `${ StaffManagementConst.basePath }/${ id }`,
            state: {
                breadcrumbSlug: {
                    id,
                    label: title,
                },
            },
        } }>
        <strong>{ title || <>&mdash;</> }</strong>
    </Link>
);

export default StaffManagementEventLinkField;

